import { namespaces } from '@common'

export const namespace = namespaces.test.value
export const schema = 'muraSchema'
export const backendDocType = 'Mura'
export const docPrivilege = 'test'
